module.exports = __webpack_public_path__ + "img/block_title_background_light.2049b918.png";